// Trip totals for one scenario + time period, honouring scenario-2 matching
// options (same dev size / same trip rates) and both entry modes (rates/direct).
// Shared by the project dashboard and the workspace results dock so the two
// never disagree.
export function periodTotals(sc, tp, scenarios, fallbackDevSize) {
  const idx = scenarios.indexOf(sc);
  const s1 = scenarios[0];
  // Any scenario after the first may "match" the first for dev size / rates.
  const devSizeVal =
    (idx > 0 && sc.sameDevSize && s1 ? parseFloat(s1.devSize) : parseFloat(sc.devSize)) ||
    parseFloat(fallbackDevSize) || 0;
  if (sc.tripEntryMode === 'direct') {
    const d = (sc.directTrips && sc.directTrips[tp.id]) || {};
    const arr = Math.round(parseFloat(d.arrivals) || 0);
    const dep = Math.round(parseFloat(d.departures) || 0);
    return { arr, dep, total: arr + dep };
  }
  const ratesFrom = (idx > 0 && sc.sameTripRates && s1) ? s1 : sc;
  const rates = (ratesFrom.tripRates && ratesFrom.tripRates[tp.id]) || {};
  const arr = Math.round((parseFloat(rates.arrivals) || 0) * devSizeVal);
  const dep = Math.round((parseFloat(rates.departures) || 0) * devSizeVal);
  return { arr, dep, total: arr + dep };
}
